import React, { lazy, PropsWithChildren, Suspense, useMemo } from "react";
import { isCorpTenant, isVesperTenant } from "@capone/common";
import { config } from "../../api/config";

export const PortalComponentProvider: React.FC<
  PropsWithChildren<{ skip?: boolean }>
> = ({ skip, children }) => {
  const PortalComponent = useMemo(() => {
    if (skip) {
      return null;
    }
    if (isCorpTenant(config.TENANT)) {
      return lazy(
        () =>
          import(
            "../../../../../cap1-application/b2b-base/src/components/Core/CorporatePortal"
          )
      );
    }
    if (isVesperTenant(config.TENANT)) {
      return lazy(
        () =>
          import(
            "../../../../../cap1-application/b2b-base/src/components/Core/VesperPortal"
          )
      );
    }
    return lazy(
      () =>
        import(
          "../../../../../cap1-application/b2b-base/src/components/Core/Portal"
        )
    );
  }, [skip]);

  if (PortalComponent == null) {
    return <>{children}</>;
  }

  return (
    <Suspense fallback="loading">
      <PortalComponent>{children}</PortalComponent>
    </Suspense>
  );
};
